// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": true,
    "raw": "6b53b21-dirty",
    "hash": "6b53b21",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "6b53b21-dirty",
    "semverString": null,
    "version": "0.0.5",
    "date": "2021-03-03T10:10:36.881Z"
};
/* tslint:enable */
